export default "__VITE_ASSET__DQ0l6WXV__"